// =============================================================================
// components/ui/CachedImage.web.tsx — WEB variant of CachedImage.
//
// On web the browser's HTTP cache already handles image caching, so there is no
// need for the native fast-image lib (and pulling it into the web bundle would
// try to resolve a native module). This variant is a thin passthrough to the
// react-native-web <Image> — same API as the native CachedImage so call sites
// don't care which platform they run on. webpack picks .web.tsx over .tsx.
// =============================================================================
import React from 'react';
import { Image, ImageProps, ImageSourcePropType } from 'react-native';

export interface CachedImageProps extends Omit<ImageProps, 'source'> {
  source: ImageSourcePropType | { uri?: string | null; headers?: Record<string, string> };
}

export default function CachedImage(props: CachedImageProps) {
  const { source, ...rest } = props;
  return <Image {...rest} source={source as ImageSourcePropType} />;
}
